export default "__VITE_ASSET__b70394a5__"